import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './App.css';
import './assets/styles/global.css';
import Layout from './components/layout/Layout/Layout';
import AuthProvider, { useAuth } from './contexts/AuthContext';
import NotificationProvider from './contexts/notification';
import { UIProvider } from './contexts/UIContext';
import { appRoutes, getRouteElement } from './routes';
import ThemeProvider from './styles/ThemeProvider';
import Login from './pages/Login/Login';
import LandingPage from './pages/Landing/LandingPage';
import CompanyRegister from './pages/CompanyRegister/CompanyRegister';

// Create a component that will handle the routes after auth is available
const AppRoutes = () => {
  const { user } = useAuth();
  const location = useLocation();
  const isLandingPage = location.pathname === '/';
  const isLoginPage = location.pathname === '/login';
  const isCompanyRegisterPage = location.pathname === '/company-register';
  
  if (isLandingPage) {
    return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/company-register" element={<CompanyRegister />} />
      </Routes>
    );
  }
  
  if (isLoginPage || isCompanyRegisterPage) {
    return (
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/company-register" element={<CompanyRegister />} />
        <Route path="/" element={<LandingPage />} />
      </Routes>
    );
  }
  
  return (
    <Layout>
      <Routes>
        {appRoutes
          .filter(route => route.path !== '/login' && route.path !== '/')
          .map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={getRouteElement(route, user)}
            />
          ))}
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider>
          <UIProvider>
            <NotificationProvider>
              <AppRoutes />
            </NotificationProvider>
          </UIProvider>
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
  
}

export default App;
